export enum UserProfileTab {
  Settings,
  Security,
  Access,
  Activity,
  Permissions,
  Connectors,
  Notifications,
  Deactivate,
  Delete,
  ResetPassword
}
